var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { openApp } from '@funny/cross-platform';
import { env, extractExistUrlParams } from '@funny/env';
import qs from 'qs';
var JSBridge = /** @class */ (function () {
    function JSBridge() {
        var _this = this;
        /**
         * bridge是否初始化
         */
        this.initBridge = false;
        /**
         * bridge在初始化之后立即需要完成的事儿
         */
        this.initializedCallbacks = [];
        this.onLoadSuccessTrigger = null;
        /**
         * 判断bridge是否加载完成
         */
        this.onLoad = new Promise(function (resolve) {
            _this.onLoadSuccessTrigger = resolve;
        });
        this.initEnv();
        this.setupWebViewJavascriptBridge(function () { });
    }
    /**
     * 初始化宿主环境的判断
     */
    JSBridge.prototype.initEnv = function () {
        if (typeof window.beforePageDestroy !== 'function') {
            window.beforePageDestroy = function () { };
        }
        if (typeof window.beforePageInit !== 'function') {
            window.beforePageInit = function () { };
        }
    };
    /**
     * 注册bridge初始化之后要做的事儿
     * @param func
     */
    JSBridge.prototype.registerInitializedHandler = function (func) {
        this.initializedCallbacks.push(func);
    };
    /**
     * 清理在bridge初始化完成之前注册的回调
     */
    JSBridge.prototype.flushInitializedHandler = function () {
        while (this.initializedCallbacks.length > 0) {
            var func = this.initializedCallbacks.pop();
            func === null || func === void 0 ? void 0 : func(window.WebViewJavascriptBridge);
        }
    };
    /**
     * jsBridge初始化
     * @param onInit 初始化完成之后执行的回调函数
     */
    JSBridge.prototype.setupWebViewJavascriptBridge = function (onInit) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!env.browser.isIOS) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initBridgeIos(onInit)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.initBridgeAndroid(onInit)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.initBridge = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * iOS端 jsBridge初始化
     * @param onInit 初始化完成之后执行的回调函数
     */
    JSBridge.prototype.initBridgeIos = function (onInit) {
        var _this = this;
        return new Promise(function (resolve) {
            var _a, _b;
            // 非唱吧和火星内
            if (!(env.browser.isChangba || env.browser.isMars)) {
                resolve(false);
                // 即使无法初始化，也要处理回调
                _this.flushInitializedHandler();
                // 通知bridge加载失败
                (_a = _this.onLoadSuccessTrigger) === null || _a === void 0 ? void 0 : _a.call(_this, false);
                return;
            }
            if (window.WebViewJavascriptBridge) {
                onInit(window.WebViewJavascriptBridge);
                resolve(true);
                // 已经加载过了 通知加载成功
                (_b = _this.onLoadSuccessTrigger) === null || _b === void 0 ? void 0 : _b.call(_this, true);
                return;
            }
            // 如果别人已经初始化了，那自己就直接加，否则增加
            if (window.WVJBCallbacks) {
                window.WVJBCallbacks.push(onInit);
            }
            else {
                window.WVJBCallbacks = [onInit];
            }
            var WVJBIframe = document.createElement('iframe');
            WVJBIframe.style.display = 'none';
            WVJBIframe.src = 'https://__bridge_loaded__';
            document.documentElement.appendChild(WVJBIframe);
            setTimeout(function () {
                var _a;
                document.documentElement.removeChild(WVJBIframe);
                // bridge已经初始化完成，清理在这之前注册的回调函数
                _this.flushInitializedHandler();
                resolve(true);
                // 通知加载成功
                (_a = _this.onLoadSuccessTrigger) === null || _a === void 0 ? void 0 : _a.call(_this, true);
            }, 0);
        });
    };
    /**
     * Android端 jsBridge初始化
     * @param onInit 初始化完成之后执行的回调函数
     */
    JSBridge.prototype.initBridgeAndroid = function (onInit) {
        var _this = this;
        return new Promise(function (resolve) {
            var _a;
            // 如果已经初始化了的话，直接返回bridge实例
            if (window.WebViewJavascriptBridge) {
                onInit(window.WebViewJavascriptBridge);
                resolve(true);
                // 已经加载过了 通知加载成功
                (_a = _this.onLoadSuccessTrigger) === null || _a === void 0 ? void 0 : _a.call(_this, true);
                return;
            }
            // Android js bridge ready
            document.addEventListener('WebViewJavascriptBridgeReady', function () {
                var _a, _b;
                // 因为在某些地方可能有人已经调过了bridge的init方法，但是为了防止init方法没有初试化到，用try-catch包裹以免影响到后续的逻辑
                try {
                    (_a = window.WebViewJavascriptBridge) === null || _a === void 0 ? void 0 : _a.init(function () { });
                }
                catch (exp) {
                    console.log('bridge的init方法被调用了两次，可能你之前已经调用过了');
                }
                onInit(window.WebViewJavascriptBridge);
                // bridge已经初始化完成，清理在这之前注册的回调函数
                _this.flushInitializedHandler();
                resolve(true);
                // 通知加载成功
                (_b = _this.onLoadSuccessTrigger) === null || _b === void 0 ? void 0 : _b.call(_this, true);
            }, false);
        });
    };
    /**
     * 断言无法初始化bridge
     */
    JSBridge.prototype.failedInitPredicate = function () {
        // 在某些场景下无法初始化bridge，比如新浪微博，只能对外抛出错误
        if (!window.WebViewJavascriptBridge) {
            throw new Error('当前宿主环境下无法初始化bridge，相关操作将无法完成');
        }
    };
    /**
     * js调APP方法
     * @param appMethodName app提供的方法
     * @param sendData 传给app的数据
     * @param afterExecute 成功/失败回调函数
     */
    JSBridge.prototype.callHandler = function (appMethodName, sendData, afterExecute) {
        afterExecute = afterExecute || (function () { });
        // 如果已经初始化，直接使用，否则将这个行为注册在回调列表中等待执行
        if (this.initBridge) {
            this.failedInitPredicate();
            window.WebViewJavascriptBridge.callHandler(appMethodName, sendData, afterExecute);
        }
        else {
            this.registerInitializedHandler(function (bridge) {
                bridge.callHandler(appMethodName, sendData, afterExecute);
            });
        }
    };
    /**
     * APP调js方法 （参数分别为:js提供的方法名  回调）
     * @param methodName js提供的方法名
     * @param afterExecute app调用之后的回调函数
     */
    JSBridge.prototype.registerHandler = function (methodName, afterExecute) {
        // 如果已经初始化，直接使用，否则将这个行为注册在回调列表中等待执行
        if (this.initBridge) {
            this.failedInitPredicate();
            window.WebViewJavascriptBridge.registerHandler(methodName, function (data, responseCallback) {
                afterExecute(data, responseCallback);
            });
        }
        else {
            this.registerInitializedHandler(function (bridge) {
                bridge.registerHandler(methodName, function (data, responseCallback) {
                    afterExecute(data, responseCallback);
                });
            });
        }
    };
    /**
     * 获取环境变量
     */
    JSBridge.prototype.getEnv = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.callHandler('env', {}, function (responseData) {
                // 安卓只能返回字符串
                try {
                    resolve(typeof responseData === 'string' ? JSON.parse(responseData) : responseData);
                }
                catch (error) {
                    reject(error);
                }
            });
        });
    };
    /**
     * 关闭当前页面
     */
    JSBridge.prototype.closePage = function () {
        this.callHandler('pageClose');
    };
    /**
     * 判断地址是否ac协议
     * @param url
     */
    JSBridge.prototype.isAcAddress = function (url) {
        return /^changba:\/\/\?ac=/i.test(url) || /^xiaochangmars:\/\/\?ac=/i.test(url);
    };
    /**
     * 埋点统计
     * @param event
     * @param action
     * @param attributes
     */
    JSBridge.prototype.setStatistics = function (event, action, attributes) {
        if (action === void 0) { action = 1; }
        this.callHandler('actionNodeNew', {
            event: event,
            action: action,
            attributes: __assign({}, attributes),
        });
    };
    /**
     * 打开新页面
     * @param closePage 注意：IOS在新容器打开网页会利用现存的老容器，而不是新建老容器。导致看不到打开的视觉效果，所以closePage默认为true
     */
    JSBridge.prototype.openPage = function (url, closePage) {
        if (closePage === void 0) { closePage = true; }
        // 如果在某些宿主环境下无法使用bridge，仍然只能使用老的方式打开页面，非ac协议无法使用pageOpen打开
        if (env.webviewType === 'new' && this.isAcAddress(url) && window.WebViewJavascriptBridge) {
            this.callHandler('pageOpen', { url: url, closePage: closePage });
        }
        else if (!env.browser.isChangba && !env.browser.isMars && this.isAcAddress(url)) {
            // 不在端内，并且打开的是ac协议
            openApp({
                targetUrl: url,
            });
        }
        // ac地址不需要解析参数
        else if (this.isAcAddress(url)) {
            window.location.href = url;
        }
        else {
            var quesIdx = url.indexOf('?');
            var targetUrl 
            // 读取到查询字符串
            = void 0;
            // 读取到查询字符串
            var queryString = '';
            // 有查询字符串
            if (quesIdx > 0) {
                queryString = url.slice(quesIdx + 1);
                targetUrl = url.slice(0, quesIdx);
            }
            else {
                targetUrl = url;
            }
            var paredParams = qs.parse(queryString);
            var distUrl = targetUrl +
                '?&' +
                extractExistUrlParams({
                    params: paredParams,
                });
            // fallback 打开一个正常的地址
            location.href = distUrl;
        }
    };
    /**
     * 打开新webview容器
     * @param customUrl 要打开的活动链接。注意：不允许有中文
     * @returns 编码后的customUrl
     */
    JSBridge.prototype.openWebView = function (customUrl, params) {
        var urlParams = qs.stringify(params);
        try {
            if (env.browser.isMars) {
                var urlEncoded = window.encodeURIComponent(customUrl + '?' + urlParams);
                this.openPage('xiaochangmars://?ac=webview&url=' + urlEncoded);
                return urlEncoded;
            }
            var urlBase64 = window.btoa(customUrl + '?' + urlParams);
            this.openPage('changba://?ac=webview&customurl=' + urlBase64);
            return urlBase64;
        }
        catch (e) {
            console.error(e);
            return '';
        }
    };
    /**
     * 轻提示
     */
    JSBridge.prototype.showToast = function (type, msg) {
        this.callHandler('toast', {
            type: type,
            msg: msg,
        });
    };
    /**
     * 弹窗提示
     */
    JSBridge.prototype.showAlert = function (title, message, confirmButtonTitle, cancelButtonTitle) {
        if (confirmButtonTitle === void 0) { confirmButtonTitle = '确认'; }
        if (cancelButtonTitle === void 0) { cancelButtonTitle = '取消'; }
        this.callHandler('alert', {
            title: title,
            message: message,
            confirmButtonTitle: confirmButtonTitle,
            cancelButtonTitle: cancelButtonTitle,
        });
    };
    return JSBridge;
}());
export default JSBridge;
